// /**
//  * Orders Delivery - list
//  */

// React
import React, {useContext} from 'react';
import {Link} from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

// UI
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from '@material-ui/core';

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../utils/rulesOrderStatus';

// Helper
import {translate} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import {Order, Status} from './interfaces';

type Data = Order;
type Props = {
  data: any;
  handleConfirmCanceleBox: (id: number) => void;
  handleInfiniteData: () => void;
  changeStatusOrderWhitId: any;
  handleOpenConfirmUpdateState: any;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 650,
      borderRadius: '4px',
    },
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    items: {
      display: 'flex',
      justifyContent: 'space-between',
      background: '#fff',
      padding: '16px',
      marginBottom: '24px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
      },
    },
    item: {
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      '@media (max-width: 768px)': {
        justifyContent: 'space-between',
        marginBottom: '16px',
      },
    },
    lable: {
      fontWeight: 500,
      color: '#8A8A8A',
      marginRight: '8px',
      '@media (max-width: 768px)': {
        fontWeight: 400,
      },
    },
    content: {
      color: '#383836',
      '@media (max-width: 768px)': {
        fontWeight: 500,
      },
    },
    actionDetail: {
      display: 'flex',
      justifyContent: 'flex-end',
      '@media (max-width: 768px)': {
        margin: '0 -16px -16px',
        '& button': {
          width: '100%',
          borderRadius: '0 0 4px  4px',
        },
        '& a': {
          width: '100%',
        },
      },
    },
  })
);

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const [selected] = React.useState<string[]>([]);
  const [valueStatus, setValueStatus] = React.useState('');
  const [openChangeStatus, setOpenChangeStatus] = React.useState(false);

  const handleChangeValueStatus = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValueStatus((event.target as HTMLInputElement).value);
  };

  const changeStatusOrder = () => {
    props.changeStatusOrderWhitId({
      ids: selected,
      status: `${valueStatus}`,
      description: null,
    });
  };

  return (
    <div className={classes.root}>
      {props.data.map((item: any, index: any) => (
        <div className={classes.items}>
          <div className={classes.item}>
            <span className={classes.lable}>سفارش دهنده: </span>
            <span className={classes.content}>{item.customerName}</span>
          </div>
          <div className={classes.item}>
            <span className={classes.lable}>شناسه سفارش: </span>
            <span className={classes.content}>{item.id}</span>
          </div>

          <div className={classes.item}>
            <span className={classes.lable}>زمان تحویل: </span>
            <span className={classes.content}>
              <span>
                {jMoment(item.deliveryDate, 'YYYY/M/D')
                  .locale('fa')
                  .format('jYY/jMM/jDD')}
              </span>
              &nbsp; &nbsp;- &nbsp; &nbsp;
              <span>
                {`${jMoment(item.deliveryStartTime, 'HH:mm:ss')
                  .locale('fa')
                  .format('HH')}
                        `}
                {`تا ${jMoment(item.deliveryEndTime, 'HH:mm:ss')
                  .locale('fa')
                  .format('HH')}`}
              </span>
            </span>
          </div>
          <div className={classes.item}>
            <span className={classes.lable}>وضعیت سفارش: </span>
            <span className={classes.content}>
              {translate(item.status, 'order')}
            </span>
          </div>
          <div className={classes.actionDetail}>
            <Link to={`/orders/${item.id}`} style={{textDecoration: 'none'}}>
              <Button size="small" variant="contained" color="secondary">
                جزئیات
              </Button>
            </Link>
          </div>
        </div>
      ))}

      <Dialog
        fullWidth
        open={openChangeStatus}
        onClose={() => setOpenChangeStatus(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle> تغییر وضعیت کلی سفارش</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">وضعیت</FormLabel>
            <RadioGroup
              aria-label="status"
              name="Status"
              value={valueStatus}
              onChange={handleChangeValueStatus}
            >
              {rulesOrderStatus[
                props.data.find((data: any) => data.id === selected[0])?.status
              ]?.map((item: Status, index: number) => (
                <FormControlLabel
                  value={item}
                  key={index}
                  control={<Radio key={index} />}
                  label={translate(item, 'order')}
                  disabled={
                    rulesAdminChangeOrderStatus[authContext.user.role].indexOf(
                      item
                    ) === -1
                  }
                />
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenChangeStatus(false)}
            variant="contained"
            color="primary"
          >
            {`خیر`}
          </Button>

          <Button
            onClick={changeStatusOrder}
            color="primary"
            variant="outlined"
          >
            {`تغییر وضعیت`}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
